import React, { useEffect, useRef, useState } from 'react';

const StorePhotos = () => {
  const [photos, setPhotos] = useState([]);
  const [file, setFile] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const fileInputRef = useRef();

  const CLOUD_NAME = 'dnybxda3y';
  const UPLOAD_PRESET = 'concert_photos';

  const fetchPhotos = () => {
    fetch('/api/store-photos')
      .then(res => res.json())
      .then(data => setPhotos(data))
      .catch(err => console.error('Error fetching photos:', err));
  };

  useEffect(() => {
    fetchPhotos();
  }, []);

  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'store_photos');  // Optional: organize in Cloudinary folder

    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: formData
      });

      const data = await res.json();

      const transformedURL = data.secure_url.replace('/upload/', '/upload/w_500,c_fit,q_auto,f_auto/');

      await fetch('/api/add-store-photo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ImageURL: transformedURL })
      });

      setFile(null);
      fetchPhotos();
    } catch (err) {
      console.error('Error uploading:', err);
    }
  };

  const handleDelete = (id) => {
    fetch(`/api/delete-store-photo/${id}`, {
      method: 'DELETE'
    })
      .then(res => res.json())
      .then(() => {
        setSelectedPhoto(null);
        fetchPhotos();
      })
      .catch(err => console.error('Error deleting photo:', err));
  };

  return (
    <div className="section">
      <h2>Store Photos</h2>

      <div className="concert-grid">
        {photos.map((photo, i) => (
          <img
            key={i}
            src={photo.ImageURL}
            alt={`Store ${i + 1}`}
            className={`concert-photo ${localStorage.getItem('isAdmin') === 'true' ? 'admin-photo-hover' : ''}`}
            onClick={() => {
              if (localStorage.getItem('isAdmin') === 'true') {
                setSelectedPhoto(photo);
              }
            }}
            style={{ cursor: localStorage.getItem('isAdmin') === 'true' ? 'pointer' : 'default' }}
          />
        ))}
      </div>

      {localStorage.getItem('isAdmin') === 'true' && (
        <div className="admin-upload-container">
          <span className="admin-upload-label">Upload Photo:</span>

          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileSelect}
          />

          <button
            className={`admin-upload-button small ${file ? 'enabled' : ''}`}
            onClick={handleFileClick}
          >
            {file ? file.name : 'Choose File'}
          </button>

          <button
            className={`admin-upload-button small ${file ? 'enabled' : ''}`}
            onClick={handleUpload}
            disabled={!file}
          >
            Upload
          </button>
        </div>
      )}

      {selectedPhoto && (
        <div className="modal-overlay" onClick={() => setSelectedPhoto(null)}>
          <div className="record-card" style={{ width: '300px', textAlign: 'center', cursor: 'default' }} onClick={(e) => e.stopPropagation()}>
            <img src={selectedPhoto.ImageURL} alt="Selected" style={{ width: '100%', marginBottom: '10px' }} />
            {localStorage.getItem('isAdmin') === 'true' && (
              <button
                className="view-new-arrivals-button"
                onClick={() => handleDelete(selectedPhoto._id)}
              >
                Delete Photo
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StorePhotos;
